/**
 * Outpaint API (AI Expand)
 * Endpoint: POST /api/outpaint/single
 */
import apiClient, { createAuthConfig, isMockApi } from "../client";
import { appendLineageToForm } from "./studio_features";
import { appendAiImage } from "./aiUpload";

const MULTIPART = (token) => ({
  ...createAuthConfig(token),
  timeout: 300000,
  headers: {
    ...createAuthConfig(token).headers,
    "Content-Type": "multipart/form-data",
  },
});

/**
 * Expand (outpaint) an image in any/all of the four directions.
 * @param {string} token - Clerk session token
 * @param {File|null} file - Image file (use null when sending image_url)
 * @param {object} [opts]
 * @param {string} [opts.image_url]
 * @param {number} [opts.left] - px to expand on left
 * @param {number} [opts.right] - px to expand on right
 * @param {number} [opts.up] - px to expand on top
 * @param {number} [opts.down] - px to expand on bottom
 * @param {string} [opts.prompt]
 * @param {string} [opts.output_format='png']
 * @returns {Promise<{success: boolean, output_url?: string, credits_used?: number, remaining_credits?: number, creation_id?: string, message?: string}>}
 */
export async function outpaintSingle(token, file, opts = {}) {
  if (isMockApi) {
    const mockSrc = opts.image_url || (file ? URL.createObjectURL(file) : "");
    return {
      success: true,
      output_url: mockSrc || "",
      credits_used: 1,
      remaining_credits: 99,
    };
  }

  const form = new FormData();
  await appendAiImage(form, file, {
    imageUrl: opts.image_url,
    requiredMessage: "outpaintSingle: provide file or opts.image_url",
  });
  if (opts.left != null) form.append("left", String(opts.left));
  if (opts.right != null) form.append("right", String(opts.right));
  if (opts.up != null) form.append("up", String(opts.up));
  if (opts.down != null) form.append("down", String(opts.down));
  if (opts.prompt) form.append("prompt", opts.prompt);
  if (opts.output_format) form.append("output_format", opts.output_format);
  appendLineageToForm(form, opts.lineage);

  const response = await apiClient.post(
    "/api/outpaint/single",
    form,
    MULTIPART(token)
  );
  return response.data;
}

export default {
  outpaintSingle,
};
